import { useTranslation } from 'react-i18next'

function DiamondSpinner() {
  const { t } = useTranslation()

  return (
    <section className="tc-trade-style6">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="info">
              <div
                className="rotate-box wow zoomIn slow"
                data-wow-delay="0.2s"
                data-speed="1"
                data-lag="0.4"
              >
                <a
                  href="#/"
                  className="rotate-circle fsz-35 rotate-text d-inline-block text-uppercase"
                >
                  <svg className="textcircle" viewBox="0 0 500 500">
                    <defs>
                      <path
                        id="textcircle"
                        d="M250,400 a150,150 0 0,1 0,-300a150,150 0 0,1 0,300Z"
                      ></path>
                    </defs>
                    <text>
                      <textPath xlinkHref="#textcircle" textLength="900">
                        {t('diamondSpinner.circleText')}
                      </textPath>
                    </text>
                  </svg>
                </a>
                <img src="/assets/images/branding/logos/logo_notext.png" alt="" className="icon" />
              </div>
              <h2 className="js-splittext-lines marcellus">
                {t('diamondSpinner.title')}
              </h2>
              <p className="js-splittext-lines marcellus">
                {t('diamondSpinner.description')}
              </p>
              <div className="btns mt-90 wow fadeInUp slow" data-wow-delay="0.2s">
                <a
                  href="#/"
                  className="butn border radius-4 border-brown2 hover-bg-brown2 text-capitalize color-brown2 me-3"
                >
                  <span className="marcellus">{t('diamondSpinner.emailButton')}</span>
                </a>
                <a
                  href="#/"
                  className="butn border radius-4 border-brown2 bg-brown2 text-capitalize text-white hover-bg-black"
                >
                  <span className="marcellus">{t('diamondSpinner.socialButton')}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default DiamondSpinner
